export default __webpack_public_path__ + "static/media/vivekJ.5f35bf05.png";